import {TrackTraceStatus} from '../types/packingSlipStatusResponse';

export enum DeliveredAt {
    HOME = 'home',
    AT_PICKUP_POINT = 'pickup_point',
    NEIGHBOURS = 'neighbours',
}

export enum TransitState {
    SORTING = 'sorting',
    OUT_FOR_DELIVERY = 'out_for_delivery',
    DELAYED = 'delayed',
    NOT_AT_HOME = 'not_at_home',
}

export interface TrackTrace {
    id: number;
    status: TrackTraceStatus;
    carrier: string;
    trackTraceCode: string | null;
    trackTraceUrl: string | null;
    isInTransit: boolean;
    transitState: TransitState | null;
    isDelivered: boolean;
    isFaulty: boolean;
    deliveredAt: DeliveredAt | null;
}
